import * as React from 'react';
import { Label } from '@patternfly/react-core';
import type { CatalogSourceType } from '@app/data/softwareCatalogData';
import { sourceTypeLabels } from '@app/data/softwareCatalogData';

/**
 * Source type is a category tag, not a status.
 * PatternFly status colors (blue/orange/green) are reserved for state.
 * All source types use the default nonstatus grey label.
 */
export interface CatalogSourceLabelProps {
  sourceType: CatalogSourceType;
}

const CatalogSourceLabel: React.FunctionComponent<CatalogSourceLabelProps> = ({ sourceType }) => (
  <Label color="grey" className="app-catalog-source-label">
    <span className="pf-v6-screen-reader">Source type: </span>
    {sourceTypeLabels[sourceType]}
  </Label>
);

export { CatalogSourceLabel };
